import { render, staticRenderFns } from "./dynamic-filter.vue?vue&type=template&id=2800d677&"
import script from "./dynamic-filter.vue?vue&type=script&lang=js&"
export * from "./dynamic-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports